import { useEffect, useState } from "react";
import Chart from "react-apexcharts";

const LineChart = (props) => {
  const { series, options, classNames } = props;

  const [chartData, setChartData] = useState([]);
  const [chartOption, setChartOption] = useState(null);

  useEffect(() => {
    setChartData(series);
    setChartOption(options);
  }, [series, options]);

  return (
    <div className={`w-full ${classNames}`}>
      {chartData.length > 0 && <Chart
      options={chartOption}
      type="line"
      width="100%"
      height="100%"
      series={chartData}
    />}
    </div>
  );
};

export default LineChart;
